export const MANAGER_ACCESS_ITEMS = [
  {
    key: "dashboard",
    title: "Dashboard",
    description:
      "Доступ до розділу з швидкою інформацією щодо заїздів/виїздів/проживаючих/SPA записів на обраний період",
    paths: ["/dashboard"],
  },
  {
    key: "bookingBoard",
    title: "Шахматка Бронювань",
    description: "Доступ до календаря бронювань",
    paths: ["/ecommerce/calendar"],
  },
  {
    key: "bookingBoardFinances",
    title: "Шахматка. Фінансова інформація",
    description:
      "Дозволити адміністратору переглядати на шахматці вартість бронювання, суму оплати, залишок до сплати, тощо",
    paths: [],
  },
  {
    key: "pricesBoard",
    title: "Шахматка Ціни",
    description: "Доступ до шахматки цін та можливість їх редагування",
    paths: ["/ecommerce/rooms-prices"],
  },
  {
    key: "restrictionsBoard",
    title: "Шахматка Обмежень",
    description: "Доступ до шахматки обмежень та можливість їх редагування",
    paths: ["/ecommerce/restrictions"],
  },
  {
    key: "channelsBoard",
    title: "Шахматка Канали",
    description:
      "Доступ до шахматки каналів продажу та можливість їх редагування",
    paths: ["/ecommerce/staff-rates"],
  },
  {
    key: "serviceOrders",
    title: "Броні",
    description:
      "Доступ до списку і деталей бронювань, а також можливість створювати і вносити зміни в бронювання",
    paths: ["/service-orders", "/service-order-invoice"],
  },
  {
    key: "clients",
    title: "Клієнти",
    description:
      "Доступ до списку та деталей клієнтів, а також можливість створювати і вносити зміни в клієнтів",
    paths: ["/clients"],
  },
  {
    key: "analytics",
    title: "Аналітика",
    description: "Доступ до аналітики",
    paths: ["/analytics"],
  },
  {
    key: "reviews",
    title: "Відгуки",
    description: "Доступ до розділу відгуків та налаштувань відгуків",
    paths: ["/reviews"],
  },
  {
    key: "finances",
    title: "Фінанси",
    description: "Доступ до фінансів, рахунків та звітів",
    paths: ["/finances"],
  },
  {
    key: "spa",
    title: "SPA",
    description: "Доступ до SPA модуля",
    paths: ["/spa"],
  },
  {
    key: "promocodes",
    title: "Промокоди",
    description: "Доступ до промокодів та історії використання",
    paths: ["/promocodes"],
  },
  {
    key: "subscription",
    title: "Підписка",
    description: "Доступ до сторінки підписки bookmenow",
    paths: ["/subscription"],
  },
  {
    key: "igStoryMaker",
    title: "IG Stories maker",
    description: "Доступ до генератора Instagram Stories",
    paths: ["/ig-story-maker"],
  },
  {
    key: "settingsCompany",
    title: "Налаштування компанії",
    description: "Доступ до сторінки налаштувань вашої компанії",
    paths: ["/settings/company"],
  },
  {
    key: "settingsStaff",
    title: "Налаштування номерів",
    description:
      "Доступ до списку номерів, а також можливість створювати і вносити зміни в номери",
    paths: ["/settings/staff"],
  },
  {
    key: "settingsPositions",
    title: "Налаштування категорій номерів",
    description: "Можливість створювати і вносити зміни в категорії номерів",
    paths: ["/settings/positions"],
  },
  {
    key: "settingsDiscounts",
    title: "Знижки",
    description: "Доступ до налаштувань знижок",
    paths: ["/settings/discounts"],
  },
  {
    key: "settingsOnlineBooking",
    title: "Налаштування Онлайн броні",
    description: "Доступ до налаштувань модуля онлайн бронювання",
    paths: ["/settings/online-booking", "/settings/online-checkin"],
  },
  {
    key: "settingsOnlinePayment",
    title: "Налаштування Онлайн оплати",
    description: "Доступ до налаштувань онлайн оплати",
    paths: ["/settings/online-payment"],
  },
  {
    key: "settingsAdditionalServices",
    title: "Налаштування додаткових послуг",
    description:
      "Доступ до додаткових послуг, а також можливість створювати і вносити зміни в додаткові послуги",
    paths: ["/settings/additional-services"],
  },
  {
    key: "teamManagers",
    title: "Налаштування Команди",
    description:
      "Доступ до списку адміністраторів, а також можливість створювати і вносити зміни в адміністраторів",
    paths: ["/team/managers"],
  },
  {
    key: "channelManager",
    title: "Менеджер каналів",
    description: "Доступ до функціоналу менеджера каналів",
    paths: ["/channel-manager"],
  },
  {
    key: "integrationsSms",
    title: "Налаштування СМС",
    description:
      "Доступ до SMS інтеграції, шаблонів, історії та налаштувань СМС повідомлень",
    paths: [
      "/integrations/sms",
      "/integrations/sms-templates",
      "/integrations/sms-manual-sends",
      "/integrations/sms-history",
      "/integrations/sms-payment",
      "/integrations/sms-settings",
    ],
  },
  {
    key: "integrationsEmail",
    title: "Налаштування емейлів",
    description:
      "Доступ до email інтеграції, шаблонів та налаштувань email повідомлень",
    paths: ["/integrations/email"],
  },
  {
    key: "telegramFinances",
    title: "Телеграм. Фінансова інформація",
    description:
      "Користувач бачитиме фінансову інформацію в телеграм сповіщеннях",
    paths: [],
  },
];

export const getDefaultManagerAccessMap = () => {
  return MANAGER_ACCESS_ITEMS.reduce((acc, item) => {
    acc[item.key] = true;
    return acc;
  }, {});
};

export function getLocalUser() {
  try {
    const localUser = localStorage.getItem("localUser");
    if (!localUser) {
      return null;
    }

    return JSON.parse(localUser);
  } catch (error) {
    console.error(error);
    return null;
  }
}

export function setLocalUser(user) {
  localStorage.setItem("localUser", JSON.stringify(user || ""));
}

export function isManagerOnly(user = getLocalUser()) {
  const rolesMap = user?.rolesMap;
  return !!rolesMap?.isManager && !rolesMap?.isOwner && !rolesMap?.isRoot;
}

export function getNormalizedManagerAccessMap(accessMap) {
  const defaultAccessMap = getDefaultManagerAccessMap();

  return MANAGER_ACCESS_ITEMS.reduce((acc, item) => {
    acc[item.key] =
      accessMap?.[item.key] === undefined
        ? defaultAccessMap[item.key]
        : !!accessMap[item.key];
    return acc;
  }, {});
}

export function hasManagerAccessKey(key, user = getLocalUser()) {
  if (!isManagerOnly(user)) {
    return true;
  }

  const accessMap = getNormalizedManagerAccessMap(user?.accessMap);
  return accessMap[key] !== false;
}

export function hasAnyManagerAccess(keys = [], user = getLocalUser()) {
  return keys.some((key) => hasManagerAccessKey(key, user));
}

export function resolveManagerAccessKeysByPath(path) {
  if (!path) {
    return [];
  }

  return MANAGER_ACCESS_ITEMS.filter((item) =>
    item.paths.some(
      (prefix) =>
        path === prefix ||
        path.startsWith(`${prefix}/`) ||
        path.startsWith(`${prefix}-`),
    ),
  ).map((item) => item.key);
}

export function hasManagerAccessToPath(path, user = getLocalUser()) {
  const accessKeys = resolveManagerAccessKeysByPath(path);
  if (!accessKeys.length) {
    return true;
  }

  return hasAnyManagerAccess(accessKeys, user);
}

export function getManagerAccessFallbackPath(user = getLocalUser()) {
  const candidates = [
    "/ecommerce/calendar",
    "/ecommerce/rooms-prices",
    "/ecommerce/restrictions",
    "/ecommerce/staff-rates",
    "/service-orders",
    "/clients",
    "/analytics",
    "/reviews/reviews-overview",
    "/finances/cash",
    "/promocodes/promocodes-overview",
    "/subscription",
    "/ig-story-maker",
    "/settings/company",
    "/settings/staff",
    "/settings/positions",
    "/settings/discounts",
    "/settings/online-booking",
    "/settings/online-payment",
    "/settings/additional-services",
    "/team/managers",
    "/channel-manager",
    "/integrations/sms",
    "/integrations/email",
  ];

  return (
    candidates.find((path) => hasManagerAccessToPath(path, user)) ||
    "/team/editprofile"
  );
}

export function syncLocalUserProfile(profile, currentUser = getLocalUser()) {
  if (!currentUser || !profile) {
    return currentUser;
  }

  const nextUser = {
    ...currentUser,
    rolesMap: profile.rolesMap || currentUser.rolesMap,
    accessMap: getNormalizedManagerAccessMap(profile.accessMap),
  };

  setLocalUser(nextUser);
  return nextUser;
}
